import { globalConstants } from "../../constants/system/global.constans";
import { userConstants } from "../../constants/user.constants";


export const globalActions = {
  setSaveStatus,
  setHeaderHeight,
  setBreadcrumbHeight,
  setLoading,
  showMenu,
  updateUserToken,
};

function setSaveStatus(isSaved, area){
    return { type: globalConstants.SET_SAVE_STATUS, isSaved, area };
  }

  function setHeaderHeight(headerHeight){
    return {type:globalConstants.SET_HEADER_HEIGHT, headerHeight}
  }
  function setBreadcrumbHeight(breadcrumbHeight){
    return {type:globalConstants.SET_BREADCRUMB_HEIGHT, breadcrumbHeight}
  }
  function setLoading(isLoading, area){
    return { type: globalConstants.SET_IS_LOADING, isLoading, area };
  }
  function showMenu(show){
    return {type:globalConstants.SHOW_MENU, show}
  }
  function updateUserToken(){
    
    let user = localStorage.getItem("user");
    if(user){
      return { type: userConstants.LOGIN_SUCCESS, user:JSON.parse(user) };
    }
  }